import styled from 'styled-components';
import { rem } from 'polished';
var PriceContainer = styled.div.withConfig({
  displayName: "PriceContainer",
  componentId: "gu0ih3-0"
})(["display:flex;flex-flow:column nowrap;padding-right:", ";"], rem(24));
export default PriceContainer;